export default "__VITE_ASSET__ba1bf59d__"